import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TwoFactorSettings from '../components/TwoFactorSettings';
import { Shield, LogOut } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';

const Setup2FA: React.FC = () => {
    const { t } = useI18n();
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        // Se o usuário já tem 2FA habilitado ou não é admin/obrigatório, redirecionar para dashboard
        // Mas precisamos ter cuidado para não redirecionar antes de carregar
        if (user?.role !== 'admin' && !user?.is_active) { // Simplificação, idealmente checaríamos se 2FA já está ok
            // Por enquanto, vamos confiar que quem cai aqui precisa de 2FA
        }
    }, [user, navigate]);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const containerStyle: React.CSSProperties = {
        minHeight: '100vh',
        background: 'linear-gradient(to bottom right, #6b21a8, #7c3aed, #a855f7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
    };

    const cardStyle: React.CSSProperties = {
        backgroundColor: 'white',
        borderRadius: '1rem',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        width: '100%',
        maxWidth: '32rem',
        padding: '2rem',
    };

    const headerStyle: React.CSSProperties = {
        textAlign: 'center',
        marginBottom: '2rem',
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <div style={headerStyle}>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                        <div style={{
                            backgroundColor: '#f3e8ff',
                            padding: '1rem',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <Shield style={{ height: '3rem', width: '3rem', color: '#9333ea' }} />
                        </div>
                    </div>
                    <h1 style={{ fontSize: '1.875rem', fontWeight: '700', color: '#1f2937', margin: '0 0 0.5rem 0' }}>
                        {t('setup2fa.required')}
                    </h1>
                    <p style={{ color: '#4b5563', margin: 0 }}>
                        {t('setup2fa.subtitle')}
                    </p>
                </div>

                <TwoFactorSettings compact={true} />

                <div style={{ marginTop: '2rem', textAlign: 'center', borderTop: '1px solid #e5e7eb', paddingTop: '1rem' }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#6b7280',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                        }}
                    >
                        <LogOut size={16} />{t('setup2fa.logoutRetry')}</button>
                </div>
            </div>
        </div>
    );
};

export default Setup2FA;
